import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessStatisticsSlice } from './get';

export const coreDataSecurityAccessStatisticsReducers = combineReducers({
	get: getCoreDataSecurityAccessStatisticsSlice.asyncReducers
});

export const coreDataSecurityAccessStatisticsWatchers = combineAllWatchers([
	getCoreDataSecurityAccessStatisticsSlice.asyncWatchers
]);
